//#Global Imports
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useRecoilState } from "recoil";
//#end Global Imports

//# Local Imports
import RecipientCard from "../../components/ui/RecipientCard";
import Typograpy from "../../components/ui/Typography";
import { recipientDetails, searchValue } from "../../store";
import { getUserRecepients } from "../../services/userDetails";
import { CloseIcon, SendMoneyIcon, Telegram, UFO } from "../../assets/Icons";
import Modal from "../../components/ui/Modal";
import { Mixpanel } from "../../constants/mixpanel";
import Pagination from "../../components/ui/Pagination";
import Loader from "../../components/ui/Loader";
import { ToastContainer } from "react-toastify";
import Toast from "../../components/ui/Toast";
import RecipientNavbar from "./RecipientNavbar";
import TableWithDetailPanel from "../../components/ui/Table/RecipientTable";
import { purposeValEnhancer } from "../../utils";
//#end Local Imports

export const PickRecipient = () => {
  const navigate = useNavigate();
  const recipientDetailsData = useRecoilValue(recipientDetails);
  const [recipient, setRecipient] = useRecoilState(recipientDetails);
  const [searchInput, setSearchInput] = useRecoilState(searchValue);
  // const [filteredRecipient, setFilteredRecipient] = useState(recipientDetailsData);
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
    ascending: false,
    totalElements: 0,
    totalPages: 0,
  });
  const { pathname } = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  type Recipient = {
    id: string;
    name: string;
    accNumber: string;
    // add other properties as needed
  };

  const [selectedRecipient, setSelectedRecipient] = useState<Recipient>({
    id: "",
    name: "",
    accNumber: "",
  });
  const [recipientInfo, setRecipientInfo] = useState();
  const [recipientList, setRecipientList] = useState<any[]>([]);

  const purposeVal = localStorage.getItem("purposeVal") || "";
  const currency =  localStorage.getItem("destCurr") || "";

  const getRecipients = async () => {
    const body = {
      page: pagination.page,
      size: pagination.size === 0 ? 10 : pagination.size,
      ascending: pagination.ascending,
      filter: searchInput,
      purposeCode:purposeValEnhancer(purposeVal),
      currency: currency,
    };
    getUserRecepients(body).then((response) => {
      setRecipientList(response?.data?.content);
      setRecipient(response?.data?.content);
      setPagination((prev) => ({
        ...prev,
        size: response?.data?.size,
        totalElements: response?.data?.totalElements,
        totalPages: response?.data?.totalPages,
      }));
      setLoading(false);
    });
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      sessionStorage.setItem("navigatingFromPage", "true");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const shouldNavigate = sessionStorage.getItem("navigatingFromPage") === "true";
      if (shouldNavigate) {
        sessionStorage.removeItem("navigatingFromPage");
        navigate("/remittance", { replace: true });
      }
    }, 500);
  }, [navigate]);

  useEffect(() => {
    return () => {
      setSearchInput("");
    };
  }, [setSearchInput]);

  useEffect(() => {
    return () => {
      setSearchInput("");
    };
  }, [pathname, setSearchInput]);

  useEffect(() => {
    getRecipients();
  }, [searchInput, pagination.page, pagination.size]);

  const handleChoseRecipient = () => {
    localStorage.setItem("recipient_id", selectedRecipient?.id);
    localStorage.setItem("recipientName", selectedRecipient?.name);
    localStorage.setItem("AcNumber", selectedRecipient?.accNumber);
    navigate("/documents");
  };

  return (
    <div className="w-full max-w-[1440px]">
      {loading && <Loader />}
      <ToastContainer autoClose={3000} position="top-right" />
      <div className="flex flex-col px-6 w-full items-center">
        {/* <div id="header" className="flex items-center justify-between">
          <div id="left" className="flex items-center space-x-3 ml-[5%]">
            <SendMoneyIcon width="32px" height="32px" />
            <span className="font-bold text-[28px]">Recipient</span>
          </div>
        </div>
        <div id="searchAndAdd" className="px-10 mt-10 space-y-5">
          <input
            name="searchRecipient"
            type="text"
            placeholder="Search Recipient Name..."
            onChange={(e) => setSearchInput(e.target.value)}
            value={searchInput}
            className="w-full p-4 bg-gray-200 rounded-md"
            autoComplete="off"
            pattern="[a-zA-Z0-9 ]{1,}"
          />
          <div className="w-full py-5 md:py-10 pl-8 md:pl-10 flex items-center text-white bg-[#14B1E7] gap-6 md:gap-12 rounded-[6px] mb-4">
            <Link onClick={() => Mixpanel.track("Add_New_Recipient")} to={"/recipient-details"}>
              <div className="w-9 h-9 md:w-[56px] md:h-[56px] bg-[transparent] rounded-full border-white border-[3px] text-xl md:text-[40px] text-white flex justify-center items-center text-center cursor-pointer add-recepient-btn">
                <div className="mb-2">+</div>
              </div>
            </Link>
            <Typograpy
              className="text-white opacity-70 text-base md:text-[30px] font-normal Recepient-add-text"
              text={"Click the “ ADD “ button to add recepients"}
              tagType="div"
            />
          </div>
        </div> */}
        <RecipientNavbar setSearchInput={setSearchInput} searchInput={searchInput} 
        handleRefresh={() => {
          setLoading(true)
          getRecipients()
        }
        } />
        <div className="w-full max-w-[1200px]">
          {recipientDetailsData?.length === 0  ? (
            <div className="flex flex-col items-center text-center mt-32 md:mt-[186px]">
              <div>
                <UFO />
              </div>
              <Typograpy
                tagType="div"
                className="text-[32px] md:text-[48px] text-primary-600 font-normal mb-9 md:mb-[17px]"
                text="No recepients found"
              />
              <Typograpy
                tagType="div"
                className="text-singleHistoryText text-[40px] md:text-[72px]"
                text={
                  <span>
                    Try the <span className="opacity-50 text-primary-600">“add”</span> button above
                  </span>
                }
              />
            </div>
          ) : 
          loading? <Loader /> :
          (
            <TableWithDetailPanel
              data={recipientList}
              selectedRecipient={selectedRecipient}
              setSelectedRecipient={setSelectedRecipient}
              setRecipientInfo={setRecipientInfo}
              handleSelected={handleChoseRecipient}
            />
          )}
          <div className="px-10">
            <Pagination
              pageSize={pagination.size}
              setPagination={setPagination}
              currentPage={pagination.page}
              totalItems={pagination.totalElements}
              // handlePageChange={() => console.log("clicked")}
              pagination={pagination}
            />
          </div>
        </div>
      </div>
      <Modal
        header="Cancel Transaction"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 rounded-[10px] lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "cancel"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="flex flex-col items-center p-10 space-y-6">
          <span className="font-ssp text-[22px]">
            Are you sure you want to cancel the transaction?
          </span>
          <div className="flex space-x-10">
            <button
              onClick={() => navigate("/remittance")}
              className="px-6 py-2 font-bold text-white rounded bg-primary-650 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="px-6 py-2 font-bold text-white rounded bg-primary font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
